<template>
  <v-col class="pa-0">
    <v-row class="ma-0 pa-0">
      <v-col align="center" cols="8" offset="2">
        <h2>{{ $translate('PARTNER_SELECT') }}</h2>
      </v-col>
      <v-col class="text-right">
        <v-icon
          size="20"
          @click="$emit('triggerPopup', { toggle: false, component: 'Login' })"
        >
          ti-close
        </v-icon>
      </v-col>
    </v-row>
    <v-col>
      <v-list>
        <v-divider></v-divider>
        <template
          v-for="(partner, index) in $store.getters[
            'Account/partnerGroupDetails'
          ].Partners"
        >
          <v-list-item :key="index" @click="redirectToPartner(partner.Name)">
            <v-list-item-title>{{ partner.Name }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
        </template>
      </v-list>
    </v-col>
    <v-card flat color="#d9d9d9" class="mt-3">
      <v-row class="mx-3 pa-4" align="center" justify="center">
        <v-col align="center">
          <p class="mb-0">{{ $translate('NOT_A_MEMBER') }}</p>
        </v-col>
        <v-col align="center" justify="center">
          <v-btn
            color="primary"
            class="primary-font-color"
            depressed
            large
            @click="$emit('triggerPopup', { toggle: true, component: 'Login' })"
          >
            {{ $translate('LOGIN') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import UserObject from '@/objects/UserObject.js';
import GoogleLogin from 'vue-google-login';
import appConfig from '../../../config/app_config';
import doRequest from '@/api/dssRequest';

export default {
  name: 'AccountLogin',
  components: {
    GoogleLogin,
  },
  data() {
    return {
      clientIdGoogle: {
        client_id:
          '819961578899-kgl1peh7ij93tgrat26v8tgou8gtj95h.apps.googleusercontent.com',
      },
      FB: {},
      valid: true,
      email: '',
      emailRules: [
        (v) => !!v || this.$translate('EMAIL_REQUIRED'),
        (v) => /.+@.+\..+/.test(v) || this.$translate('EMAIL_VALID'),
      ],
      password: '',
      passwordRules: [(v) => !!v || this.$translate('PASSWORD_REQUIRED')],
      errorMessage: '',
    };
  },
  mounted() {},
  methods: {
    redirectToPartner(name) {
      const payload = {
        PartnerName: name,
      };
      console.log('Benjamin name', name);
      doRequest(
        (response) => {
          console.log(
            'getPartnerUrl is called correctly with a response: ',
            response
          );
          window.location.href = response.data.Url;
        },
        (error) => {
          console.log('getPartnerUrl error', error);
        },
        'getPartnerUrl',
        this.$store.getters['Account/partnerGroupDetails'].AccountId,
        payload
      );
    },
  },
};
</script>

<style scoped lang="scss"></style>
